import { Link, useLocation } from "react-router-dom";

/**
 * The destinations inside one space, present on every screen inside it so
 * reaching another one is one click rather than a trip back through the
 * landing page first (issue #41).
 *
 * Projects has no route of its own — the landing page is where the project
 * list lives — so its match also covers an open project, the way NavLink's
 * own prefix matching would if there were a single `/projects` prefix to
 * give it.
 */
const items = (spaceId: string) => [
  {
    label: "Projects",
    href: `/spaces/${spaceId}`,
    match: (path: string) =>
      path === `/spaces/${spaceId}` || path.startsWith(`/spaces/${spaceId}/projects/`),
  },
  {
    label: "Content",
    href: `/spaces/${spaceId}/content`,
    match: (path: string) => path.startsWith(`/spaces/${spaceId}/content`),
  },
  {
    label: "People",
    href: `/spaces/${spaceId}/members`,
    match: (path: string) => path.startsWith(`/spaces/${spaceId}/members`),
  },
  {
    label: "Settings",
    href: `/spaces/${spaceId}/settings`,
    match: (path: string) => path.startsWith(`/spaces/${spaceId}/settings`),
  },
  {
    label: "Keys",
    href: `/spaces/${spaceId}/keys`,
    match: (path: string) => path.startsWith(`/spaces/${spaceId}/keys`),
  },
  // An MCP setup page joins this list once #42 lands.
];

export function SpaceNav({ spaceId }: { spaceId: string }) {
  const { pathname } = useLocation();

  return (
    <nav className="space-nav" aria-label="Space">
      {items(spaceId).map((item) => {
        const isActive = item.match(pathname);
        return (
          <Link
            key={item.label}
            to={item.href}
            className={isActive ? "active" : ""}
            aria-current={isActive ? "page" : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
